/**
 * The three-bar "Refine" glyph shared by the professional grid tabs' filter
 * controls — the mobile Refine circle ({@link SearchFilter.mobile}) and the
 * items-bar Refine button ({@link ProfessionalItemsBar}). One copy so the two
 * entry points can never drift.
 */
export const RefineIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 15 15"
        fill="none"
        aria-hidden="true"
        className="shrink-0"
    >
        <path
            d="M1.5 3.75h12M3.5 7.5h8M5.5 11.25h4"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
        />
    </svg>
);
